import { queryOptions } from "@tanstack/react-query";

import { omgApiClient } from "@lib/api/omgApiClient";

export interface DiscountInfo {
  code: string;
  title: string;
  message: string | null;
  discountPercent: number;
}

export const getDiscountQueryOptions = (code: string | null) => {
  return queryOptions({
    queryKey: ["discount", code],
    queryFn: async () => {
      const response = await omgApiClient.get<DiscountInfo>(
        `/discounts/${code}`,
      );
      return response.data;
    },
    enabled: !!code,
  });
};
